import { forwardRef } from 'react';
import styled from 'styled-components';
import { Box, media, Stack, MainNav, useMargaret } from '@koob/margaret';
import Breadcrumb from 'components/Breadcrumb';
import NotificationsDropdown from 'components/NotificationsDropdown';

// KD-3391: paddingVertical 0.5 so the compose trip header fits inside the
// 80px min-height and the navbar lines up with the sidebar logo strip.
export const HeaderBase = styled(Box).attrs({ paddingVertical: 0.5 })`
  min-height: 80px;
  background-color: #ffffff;
  box-shadow: inset 0 -1px 0 ${({ theme }) => theme.separator};
  padding-left: ${({ theme }) => theme.spacing()};
  padding-right: ${({ theme }) => theme.spacing()};
  display: flex;
  align-items: center;
  z-index: 10;

  ${media.tablet`
    padding-left: ${({ theme }) => theme.spacing(2)};
    padding-right: ${({ theme }) => theme.spacing(2)};
  `}
`;

const Trigger = styled.div`
  position: relative;
  z-index: 2;
`;

const Header = (
  { leftElement = <Breadcrumb />, rightElement, children },
  ref,
) => {
  const { isMobile } = useMargaret();

  return (
    <HeaderBase ref={ref}>
      <Stack direction="column" size="full" gutterSize={1}>
        <Stack
          size="full"
          alignX="space-between"
          alignY="center"
          gutterSize={1}
        >
          <Stack alignY="center" gutterSize={1}>
            {isMobile && (
              <Trigger>
                <MainNav.Trigger />
              </Trigger>
            )}
            <Stack>{leftElement}</Stack>
          </Stack>
          {/* KD-3391: on compose, the page portals its trip header
              (ComposeHeader) into this slot */}
          <div
            id="koob-navbar-trip-designer-slot"
            style={{ flex: '1 1 auto', minWidth: 0 }}
          />
          <Stack alignY="center" gutterSize={1}>
            {rightElement}
            <NotificationsDropdown />
          </Stack>
        </Stack>
        {children}
      </Stack>
    </HeaderBase>
  );
};

export default forwardRef(Header);
